import React, { useContext, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import {
  Typography,
  Grid,
  Divider,
  useTheme,
  useMediaQuery,
  Stack,
  Box,
  IconButton,
  Chip,
  CircularProgress,
} from '@mui/material';
import { poppins500, poppins400 } from 'theme/common.style';
import PaymentHistoryPopup from '../PaymentHistoryPopup';
import { DEPOSIT_MANAGER_DETAILS } from 'constant/app.config';
import { getApiCall } from 'api/apiService';
import DetailsMiddleContent from './DetailsMiddleContent';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import { datacontext } from 'modules/AppLayout/AppLayout';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import InitiateDepositRefund from '../InitiateDepositRefund';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

const PaymentTicIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_39041_106745)">
        <path
          d="M5 12L10 17L20 7"
          stroke="#40AB5F"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_39041_106745">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const TransferredArrowIcon = () => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.36401 8.53022L4.94975 9.94442L0 4.99462L4.94975 0.0449219L6.36401 1.45913L3.8655 3.95762H12.0035C14.2126 3.95762 16.0035 5.74842 16.0035 7.95762V9.95762H14.0035V7.95762C14.0035 6.85302 13.108 5.95762 12.0035 5.95762H3.79136L6.36401 8.53022Z"
        fill="#03C6DB"
      />
    </svg>
  );
};

const ViewedIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_39041_106764)">
        <path
          d="M12.9948 15.1654C14.1914 15.1654 15.1615 14.1953 15.1615 12.9987C15.1615 11.8021 14.1914 10.832 12.9948 10.832C11.7982 10.832 10.8281 11.8021 10.8281 12.9987C10.8281 14.1953 11.7982 15.1654 12.9948 15.1654Z"
          stroke="#2E4BEB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.0052 20.5846C8.67187 20.5846 5.06112 18.0572 2.17188 13.0013C5.06112 7.94539 8.67187 5.41797 13.0052 5.41797C17.3385 5.41797 20.9493 7.94539 23.8385 13.0013C23.3835 13.7986 22.909 14.5331 22.4183 15.2037"
          stroke="#2E4BEB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.25 20.5846L18.4167 22.7513L22.75 18.418"
          stroke="#2E4BEB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_39041_106764">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const RefundIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 1.75C15.3326 1.75 19.25 5.66738 19.25 10.5C19.25 15.3326 15.3326 19.25 10.5 19.25C8.45993 19.253 6.48345 18.5402 4.91489 17.2358L4.70139 17.0529L5.49064 15.3886C6.61762 16.5437 8.10909 17.2739 9.71261 17.4557C11.3161 17.6374 12.9332 17.2595 14.2901 16.386C15.647 15.5124 16.6604 14.1969 17.1588 12.6619C17.6572 11.127 17.6099 9.46708 17.025 7.96303C16.44 6.45897 15.3534 5.20322 13.949 4.40831C12.5445 3.6134 10.9086 3.32817 9.31801 3.60088C7.72743 3.8736 6.27994 4.68752 5.22053 5.90488C4.16112 7.12224 3.55486 8.66825 3.50439 10.2812L3.50001 10.5H5.68751L3.31976 15.5015C2.29532 14.0351 1.74724 12.2888 1.75001 10.5C1.75001 5.66738 5.66739 1.75 10.5 1.75ZM11.375 5.25V7H13.5625V8.75H8.75001C8.64068 8.7498 8.53524 8.79054 8.45445 8.86419C8.37366 8.93785 8.32337 9.03909 8.31349 9.14797C8.30362 9.25685 8.33486 9.36548 8.40108 9.45248C8.46729 9.53947 8.56368 9.59852 8.67126 9.618L8.75001 9.625H12.25C12.8302 9.625 13.3866 9.85547 13.7968 10.2657C14.207 10.6759 14.4375 11.2323 14.4375 11.8125C14.4375 12.3927 14.207 12.9491 13.7968 13.3593C13.3866 13.7695 12.8302 14 12.25 14H11.375V15.75H9.62501V14H7.43751V12.25H12.25C12.3593 12.2502 12.4648 12.2095 12.5456 12.1358C12.6264 12.0621 12.6766 11.9609 12.6865 11.852C12.6964 11.7432 12.6652 11.6345 12.5989 11.5475C12.5327 11.4605 12.4363 11.4015 12.3288 11.382L12.25 11.375H8.75001C8.16985 11.375 7.61345 11.1445 7.20321 10.7343C6.79298 10.3241 6.56251 9.76766 6.56251 9.1875C6.56251 8.60734 6.79298 8.05094 7.20321 7.6407C7.61345 7.23047 8.16985 7 8.75001 7H9.62501V5.25H11.375Z"
        fill="white"
      />
    </svg>
  );
};
const CancelRequestIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_39041_183272)">
        <path
          d="M8.75 0.75C3.91781 0.75 0 4.66781 0 9.5C0 14.3322 3.91781 18.25 8.75 18.25C13.5822 18.25 17.5 14.3322 17.5 9.5C17.5 4.66781 13.5822 0.75 8.75 0.75ZM8.75 16.6094C4.82344 16.6094 1.64062 13.4266 1.64062 9.5C1.64062 5.57344 4.82344 2.39062 8.75 2.39062C12.6766 2.39062 15.8594 5.57344 15.8594 9.5C15.8594 13.4266 12.6766 16.6094 8.75 16.6094Z"
          fill="white"
        />
        <path
          d="M11.4844 5.125L8.75 7.85938L6.01562 5.125L4.375 6.76562L7.10938 9.5L4.375 12.2344L6.01562 13.875L8.75 11.1406L11.4844 13.875L13.125 12.2344L10.3906 9.5L13.125 6.76562L11.4844 5.125Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_39041_183272">
          <rect
            width="17.5"
            height="17.5"
            fill="white"
            transform="translate(0 0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const RedColorRefundIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_39041_185086)">
        <path
          d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C9.66849 22.0034 7.40966 21.1888 5.61701 19.698L5.37301 19.489L6.27501 17.587C7.56299 18.9071 9.26753 19.7416 11.1001 19.9493C12.9327 20.157 14.7808 19.7252 16.3316 18.7268C17.8823 17.7285 19.0405 16.225 19.6101 14.4708C20.1796 12.7166 20.1256 10.8195 19.4571 9.1006C18.7886 7.38169 17.5468 5.94654 15.9417 5.03807C14.3366 4.1296 12.467 3.80362 10.6492 4.1153C8.83135 4.42697 7.17707 5.35717 5.96632 6.74843C4.75556 8.1397 4.0627 9.90657 4.00501 11.75L4.00001 12H6.50001L3.79401 17.716C2.62322 16.0401 1.99685 14.0444 2.00001 12C2.00001 6.477 6.47701 2 12 2ZM13 6V8H15.5V10H10C9.87507 9.99977 9.75456 10.0463 9.66223 10.1305C9.5699 10.2147 9.51243 10.3304 9.50114 10.4548C9.48985 10.5793 9.52556 10.7034 9.60123 10.8028C9.67691 10.9023 9.78706 10.9697 9.91001 10.992L10 11H14C14.6631 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.6631 16 14 16H13V18H11V16H8.50001V14H14C14.125 14.0002 14.2455 13.9537 14.3378 13.8695C14.4301 13.7853 14.4876 13.6696 14.4989 13.5452C14.5102 13.4207 14.4745 13.2966 14.3988 13.1972C14.3231 13.0977 14.213 13.0303 14.09 13.008L14 13H10C9.33697 13 8.70109 12.7366 8.23224 12.2678C7.7634 11.7989 7.50001 11.163 7.50001 10.5C7.50001 9.83696 7.7634 9.20107 8.23224 8.73223C8.70109 8.26339 9.33697 8 10 8H11V6H13Z"
          fill="#EA4342"
        />
      </g>
      <defs>
        <clipPath id="clip0_39041_185086">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const RequestedIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.771 16.8233L16.303 18.3553L21.6653 12.993L16.303 7.63086L14.771 9.16292L17.4777 11.8696H8.66146C6.26822 11.8696 4.32812 13.8097 4.32812 16.203V18.3696H6.49479V16.203C6.49479 15.0063 7.46484 14.0363 8.66146 14.0363H17.558L14.771 16.8233Z"
        fill="#8424D5"
      />
    </svg>
  );
};
const PartiallyPaidIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_39041_185060)">
        <path
          d="M21 17H13L9.5 12H3"
          stroke="#3854B7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.0028 7H13.0028L9.50781 12"
          stroke="#3854B7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 10L21 7L18 4"
          stroke="#3854B7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 20L21 17L18 14"
          stroke="#3854B7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_39041_185060">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const DownArrowIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_39041_106713)">
        <path
          d="M2.59938 4.01469L1.64063 4.97885L7.00313 10.3359L12.3656 4.97344L11.4069 4.01469L7.00313 8.41844L2.59938 4.01469Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_39041_106713">
          <rect
            width="13"
            height="13"
            fill="white"
            transform="matrix(0 -1 1 0 0.5 13.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

function DetailsPopup(props) {
  const {
    openDetailsPopup,
    handleCloseDetails,
    profileDetails,
    buyerId,
    getTableData,
    isFromBuyerRegister,
    getListInfo,
    manageOfferClick,
    fromVendorStatus,
  } = props;
  const theme = useTheme();
  const params = useParams();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesxs = useMediaQuery(theme.breakpoints.down(500));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const { realTimeLog } = useContext(datacontext);
  const { setDisplayExchange } = useContext(PropertyContext);

  const [PaymentHistoryPopupopen, setPaymentHistoryPopup] = useState(false);
  const handleClosePopup = () => {
    setPaymentHistoryPopup(false);
  };

  const Address = profileDetails?.PropertyDetails?.propertyAddress?.streetName;

  const [depositDetailsData, setDepositDetailsData] = useState({});
  const [depositDetailsLoader, setDepositDetailsLoader] = useState(false);
  const [processRefundOpen, setProcessRefundOpen] = useState(false);

  const handleCloses = () => {
    setProcessRefundOpen(false);
  };

  const propertyId = profileDetails?.PropertyDetails?.property?.propertyId;
  const paramsPropertyId = params?.dashboardId;
  // const propertyId = 162;
  // const buyerId = 174;

  const input = {
    propertyId: propertyId || paramsPropertyId,
    buyerId: buyerId,
  };

  const getDetailsData = async () => {
    setDepositDetailsLoader(true);
    try {
      const res = await getApiCall(DEPOSIT_MANAGER_DETAILS, input);

      if (res?.status == 200) {
        setDepositDetailsData(res?.data);
      }
    } catch (error) {
      console.error('Error fetching deposit table data:', error);
    } finally {
      setDepositDetailsLoader(false);
    }
  };

  useEffect(() => {
    getDetailsData();
  }, [realTimeLog, profileDetails]);

  const getChipStylesByStatus = (status) => {
    switch (status) {
      case 'Paid':
        return { backgroundColor: '#CEFECE', color: '#3FBA20' };
      case 'Requested':
        return { backgroundColor: '#F3E8FE', color: '#8424D5' };
      case 'Refunded':
        return { backgroundColor: '#FEEDD6', color: '#B46E46' };
      case 'Partially Paid':
        return { backgroundColor: '#DCEAFE', color: '#3854B7' };
      case 'Viewed':
        return { backgroundColor: '#E0E7FE', color: '#3E50BB' };
      case 'Overdue':
        return { backgroundColor: '#FDE2E2', color: '#B44E4F' };
      case 'Transferred':
        return { backgroundColor: '#E2FDFC', color: '#03C6DB' };
      default:
        return { backgroundColor: '#E0E0E0', color: '#000000' };
    }
  };

  const HistoryIcons = (status) => {
    switch (status) {
      case 'Requested':
        return [<RequestedIcon />];
      case 'Transferred':
        return [<TransferredArrowIcon />];
      case 'Paid':
        return [<PaymentTicIcon />];
      case 'Viewed':
        return [<ViewedIcon />];
      case 'Partially Paid':
        return [<PartiallyPaidIcon />];
      case 'Refunded':
        return [<RedColorRefundIcon />];
      case 'Overdue':
        return [<RunningWithErrorsIcon sx={{ color: '#B44E4F' }} />];
      default:
        return [];
    }
  };

  const OfferPriceColor = (item) => {
    const isPositive =
      item?.paymentStatus === 'Paid' ||
      item?.paymentStatus === 'Transferred' ||
      item?.paymentStatus === 'PartiallyPaid';

    const isNegative = item?.paymentStatus === 'Refunded';

    const colorMap = {
      Paid: '#40AB5F',
      Transferred: '#A1FFA1',
      Refunded: '#EA4342',
    };

    const textColor = colorMap[item?.paymentStatus] || '#C4C4C4';
    const prefix = isNegative ? '-' : isPositive ? '+' : '';

    return (
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 600,
          fontFamily: 'Poppins',
          color: textColor,
          textAlign: { xs: 'left', sm: 'right' },
        }}
      >
        {prefix} {item?.formattedAmount ?? '-'}
      </Typography>
    );
  };

  const buyerName = depositDetailsData?.depositDetails?.buyerName;
  const buyerSurName = depositDetailsData?.depositDetails?.buyerSurName;

  const buyerNameIndividual =
    buyerName && buyerSurName ? `${buyerName} ${buyerSurName}` : '-';

  return (
    <>
      <Dialog
        open={openDetailsPopup}
        onClose={handleCloseDetails}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matches700 ? '100%' : '1018px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
            paddingBottom: matches700 ? '90px' : '',
          },
        }}
      >
        <Box
          sx={{
            ...poppins400,
            fontSize: matchessm ? '12px' : '14px',
            color: '#666666',
          }}
        >
          {Address}
        </Box>
        <Stack
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Stack flexDirection={'row'} alignItems={'center'} mt={1} gap={2}>
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchesxs ? '20px' : '24px',
              }}
            >
              {buyerNameIndividual}
            </Typography>

            <Chip
              variant="container"
              label={depositDetailsData?.depositDetails?.status}
              sx={{
                ...getChipStylesByStatus(
                  depositDetailsData?.depositDetails?.status
                ),
                fontWeight: 600,
                fontSize: matchessm ? '10px' : '13px',
                borderRadius: '25px',
                fontFamily: 'poppins',
              }}
            />
          </Stack>
          <Box>
            <IconButton
              onClick={handleCloseDetails}
              sx={{ backgroundColor: '#F0F0F0' }}
              size="medium"
            >
              <DownArrowIcon />
            </IconButton>
          </Box>
        </Stack>
        <Box>
          <Typography
            sx={{
              color: '#666666',
              fontSize: '12px',
              fontFamily: 'poppins',
              fontWeight: 400,
            }}
          >
            Deposit ID: 1
          </Typography>
        </Box>
        {/* ------- */}
        <Grid container>
          <DetailsMiddleContent
            depositDetailsData={depositDetailsData}
            buyerId={buyerId}
            getDetailsData={getDetailsData}
            getTableData={getTableData}
            isFromBuyerRegister={isFromBuyerRegister}
            profileDetails={profileDetails}
            getListInfo={getListInfo}
            manageOfferClick={manageOfferClick}
            fromVendorStatus={fromVendorStatus}
            handleCloseDetails={handleCloseDetails}
          />
        </Grid>

        <Box
          sx={{
            fontFamily: 'poppins',
            fontWeight: 400,
            fontSize: matchessm ? '18px' : '24px',
            mt: '30px',
          }}
        >
          Payment History
        </Box>

        <Box
          className="scroll-enabled"
          sx={{
            height: matchessm ? '' : '333px',
            width: '100%',
            maxWidth: 1018,
            borderRadius: 1,
            bgcolor: '#F8F8F8',
            p: 2,
            mt: 2,
            overflowY: matchessm ? '' : 'auto',
          }}
        >
          <Stack spacing={2}>
            {depositDetailsLoader ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '300px',
                }}
              >
                <CircularProgress color="success" />
              </Box>
            ) : depositDetailsData?.paymentHistories === 0 ||
              !depositDetailsData?.paymentHistories?.length ? (
              <Box
                sx={{
                  height: '300px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: 'poppins',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#666666',
                }}
              >
                No data found
              </Box>
            ) : (
              depositDetailsData?.paymentHistories?.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    border: '1px solid #E9E9E9',
                    bgcolor:
                      item?.paymentStatus == 'Refunded' ? '#e9d5d5' : '#FFFFFF',
                    borderRadius: 1,
                  }}
                >
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={9}>
                      <Stack direction="row" alignItems="center" gap={2} p={2}>
                        {HistoryIcons(item?.paymentStatus)}
                        <Stack spacing={0.5}>
                          <Typography
                            sx={{
                              fontSize: 14,
                              fontWeight: 600,
                              fontFamily: 'Poppins',
                            }}
                          >
                            {item?.paymentStatus ?? '-'} -{' '}
                            {item?.lastUpdatedDate ?? '-'}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: 12,
                              fontWeight: 400,
                              fontFamily: 'Poppins',
                            }}
                          >
                            {item?.depositType ?? '-'}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={3}
                      p={2}
                      display={matchessm && 'flex'}
                      justifyContent={matchessm && 'center'}
                    >
                      {OfferPriceColor(item)}
                    </Grid>
                  </Grid>

                  <Divider
                    sx={{
                      backgroundColor:
                        item?.paymentStatus === 'Refunded' && 'white',
                      height: '1px', // optional for horizontal lines
                    }}
                  />

                  <Box px={2.5} py={1.25}>
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                      }}
                    >
                      {item?.description ?? '-'}
                    </Typography>
                  </Box>
                </Box>
              ))
            )}
          </Stack>
        </Box>
        <Box sx={{ mt: 5, width: '100%' }}>
          <Divider variant="fullWidth" />
        </Box>
        <Grid
          container
          display={'flex'}
          flexDirection={matchessm && 'column'}
          alignItems={'center'}
          justifyContent={'space-between'}
          mt={2}
          spacing={matchessm && 1}
        >
          <Grid
            item
            sx={{
              display: 'flex',
              flexDirection: matchessm ? 'column' : 'row',
              alignItems: 'center',
              gap: 2,
              width: matchessm ? '100%' : 'auto',
            }}
          >
            {depositDetailsData?.depositDetails?.needToConfirmAmount !=
              null && (
              <Button
                variant="contained"
                disabled={profileDetails?.PropertyDetails?.isArchived === 1}
                startIcon={
                  <CheckCircleOutlinedIcon sx={{ fontSize: '20px' }} />
                }
                sx={{
                  px: '39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: 400,
                  fontFamily: 'poppins',
                  backgroundColor: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                  '&:hover': {
                    backgroundColor: '#4CA4D6',
                    color: '#FFF',
                  },
                }}
                onClick={() => setPaymentHistoryPopup(true)}
              >
                Mark as Received
              </Button>
            )}
            {(depositDetailsData?.depositDetails?.status === 'Paid' ||
              depositDetailsData?.depositDetails?.status === 'Transferred') && (
              <Button
                variant="contained"
                startIcon={<RefundIcon />}
                disabled
                sx={{
                  px: '39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: 400,
                  fontFamily: 'poppins',
                  backgroundColor: '#EA4342',
                  borderRadius: '5px',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#EA4342',
                    color: '#FFF',
                  },
                }}
                onClick={() => setProcessRefundOpen(true)}
              >
                Process Refund
              </Button>
            )}
            {depositDetailsData?.depositDetails?.status == 'Overdue' && (
              <Button
                variant="contained"
                startIcon={<CancelRequestIcon />}
                sx={{
                  px: '39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: 400,
                  fontFamily: 'poppins',
                  backgroundColor: '#EA4342',
                  borderRadius: '5px',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#EA4342',
                    color: '#FFF',
                  },
                }}
                disabled
                // onClick={() => setPaymentHistoryPopup(true)}
              >
                Cancel Request
              </Button>
            )}
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              flexDirection: matchessm ? 'column' : 'row',
              alignItems: 'center',
              width: matchessm ? '100%' : 'auto', // or omit "auto" to fallback to default
            }}
          >
            <Button
              onClick={() => {
                handleCloseDetails();
                setDisplayExchange(true);
              }}
              variant="outlined"
              sx={{
                px: '39px',
                height: '41px',
                width: matchessm ? '100%' : 'auto', // uncomment if you want full-width button on mobile
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: 400,
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: '#666666',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                },
              }}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </Dialog>
      <PaymentHistoryPopup
        open={PaymentHistoryPopupopen}
        setPaymentHistoryPopup={setPaymentHistoryPopup}
        onClose={handleClosePopup}
        confirmAmount={depositDetailsData?.depositDetails}
        isDetailsIndividual={true}
        actionBuyerId={buyerId}
        getDetailsData={getDetailsData}
        getTableData={getTableData}
        isFromBuyerRegister={isFromBuyerRegister}
        getListInfo={getListInfo}
      />
      <InitiateDepositRefund
        open={processRefundOpen}
        profileDetails={profileDetails}
        buyerNameIndividual={buyerNameIndividual}
        depositDetailsData={depositDetailsData}
        buyerId={buyerId}
        getDetailsData={getDetailsData}
        getTableData={getTableData}
        isFromBuyerRegister={isFromBuyerRegister}
        onClose={handleCloses}
      />

      {/* <InitiateDepositRefund  buyerId={buyerId}  getDetailsData={getDetailsData} isFromBuyerRegister={isFromBuyerRegister} /> */}
    </>
  );
}

export default DetailsPopup;
